import { render, staticRenderFns } from "./sidebar-link.vue?vue&type=template&id=306c0477&scoped=true"
import script from "./sidebar-link.vue?vue&type=script&lang=js"
export * from "./sidebar-link.vue?vue&type=script&lang=js"
import style0 from "./sidebar-link.vue?vue&type=style&index=0&id=306c0477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306c0477",
  null
  
)

export default component.exports